<template>
  <v-card @click="$emit('show-modal')" height="100%">
    <v-card-item>
      <v-card-title>
        <h3 class="d-flex align-center text-wrap">
          <span class="mr-2">
            <slot name="icon" />
          </span>
          <span>
            <slot name="title" />
          </span>
        </h3>
      </v-card-title>
    </v-card-item>

    <v-card-text class="content pa-0">
      <slot name="content" />
    </v-card-text>

    <v-card-actions class="d-none d-sm-flex justify-center">
      <slot name="action" />
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';

const componentOptions: ComponentOptions = {
  name: 'CardTemplate',
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  min-height: 4.375rem;
  text-align: center;
}
H3.text-wrap {
  min-height: 3.438rem;
}
@media (max-width: 440px) {
  .content {
    min-height: auto;
    text-align: left;
  }
  H3.text-wrap {
    min-height: auto;
  }
}
</style>
